import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';
import { OnlineStep, StoreStep } from '@upstart/harmony/lib/constants';
import { OnlinePseudoSteps } from '../../util/constants';

// Pickup and delivery are psudeo steps
const stepValues = [
  ...Object.values(OnlineStep)
    .concat(Object.values(StoreStep))
    .concat(Object.values(OnlinePseudoSteps)),
];

function FilterCompletedSteps({ disabled, onChange, tableDefinition }) {
  // get all the columns that are online/instore steps
  const options = tableDefinition.columns
    .map((column) => ({ name: column.label, value: column.dataField }))
    .filter((option) => stepValues.includes(option.value));

  const [selectedOptions, setSelectedOptions] = useState([]);
  return (
    <Typeahead
      id="completed-steps-typeahead"
      placeholder="Completed Steps"
      disabled={disabled}
      className="completed-steps-typeahead"
      labelKey="name"
      multiple
      selectHintOnEnter
      clearButton
      options={options}
      selected={selectedOptions}
      onChange={(selected) => {
        setSelectedOptions(selected);
        const selectedValues = selected.map(
          (selectedOption) => selectedOption.value,
        );
        onChange(selectedValues);
      }}
    />
  );
}

FilterCompletedSteps.propTypes = {
  tableDefinition: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default FilterCompletedSteps;
